import { store } from '@/store';
import Vue from 'vue';
import VueI18n from 'vue-i18n';

import de from '@/lang/de';
import en from '@/lang/en';
import es from '@/lang/es';
import fi from '@/lang/fi';
import fr from '@/lang/fr';
import it from '@/lang/it';
import ja from '@/lang/ja';
import nbNO from '@/lang/nb-NO';
import nl from '@/lang/nl';
import nnNO from '@/lang/nn-NO';
import pl from '@/lang/pl';
import ptBR from '@/lang/pt-BR';
import ptPT from '@/lang/pt-PT';
import sr from '@/lang/sr';
import sv from '@/lang/sv';
import tr from '@/lang/tr';
import untranslated from '@/lang/untranslated';

Vue.use(VueI18n);

function withUntranslated(messages) {
    const merged = { ...messages };

    Object.keys(untranslated).forEach((namespace) => {
        merged[namespace] = {
            ...messages[namespace],
            ...untranslated[namespace],
        };
    });

    return merged;
}

const i18n = new VueI18n({
    locale: store.getters.lang ?? 'en',
    fallbackLocale: 'en',
    messages: {
        de: withUntranslated(de),
        en: withUntranslated(en),
        es: withUntranslated(es),
        fi: withUntranslated(fi),
        fr: withUntranslated(fr),
        it: withUntranslated(it),
        ja: withUntranslated(ja),
        'nb-NO': withUntranslated(nbNO),
        nl: withUntranslated(nl),
        'nn-NO': withUntranslated(nnNO),
        pl: withUntranslated(pl),
        'pt-BR': withUntranslated(ptBR),
        'pt-PT': withUntranslated(ptPT),
        sr: withUntranslated(sr),
        sv: withUntranslated(sv),
        tr: withUntranslated(tr),
    },
});

document.documentElement.lang = i18n.locale;

export default i18n;
